// extracted by mini-css-extract-plugin
export default {"navigateBtnCol":"oneWayInterviewConfiguration_navigateBtnCol__YRUpn","dividerLine":"oneWayInterviewConfiguration_dividerLine__A2JhK"};